module.exports = __webpack_public_path__ + "static/media/icon-temperature-dark.9f145642.svg";